import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { format } from 'date-fns';
import React from 'react';

interface Props {
  month: Date;
  onPrevious: () => void;
  onNext: () => void;
  canGoPrevious: boolean;
  canGoNext: boolean;
}

export const CalendarMonthNavigator = ({
  month,
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext
}: Props) => (
  <div className="employee-attendance-calendar-page__month-nav">
    <button
      type="button"
      className="employee-attendance-calendar-page__month-nav-btn"
      onClick={onPrevious}
      disabled={!canGoPrevious}
      aria-label="Previous month"
    >
      <ChevronLeftIcon fontSize="small" aria-hidden />
    </button>
    <span className="employee-attendance-calendar-page__month-nav-label">
      {format(month, 'MMMM yyyy')}
    </span>
    <button
      type="button"
      className="employee-attendance-calendar-page__month-nav-btn"
      onClick={onNext}
      disabled={!canGoNext}
      aria-label="Next month"
    >
      <ChevronRightIcon fontSize="small" aria-hidden />
    </button>
  </div>
);
